/*=========================================================================================
  File Name: index.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import {
  getToken
} from '@/utils/auth'
import FrontendRoutes from './frontend'
Vue.use(Router)

var allRoutes = FrontendRoutes
export const constantRoutes = allRoutes // Concat frontend and backend routes

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: constantRoutes
})

router.beforeEach((to, from, next) => {
  const redirectPath = window.location.pathname;

  if (getToken()) {
    next();
  } else {
    next();
  }
})


router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')

  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
